import { privateApi } from 'services';
import { ConfiguratorData, ConfiguratorDataFormValues } from './types';

const fetchConfiguratorData = (
    jobGroupId: string,
    body: Partial<ConfiguratorDataFormValues>,
): Promise<ConfiguratorData> =>
    privateApi.post<ConfiguratorData>(`job-groups/${jobGroupId}/importer-configurator-data`, body);

export const ConfiguratorDataGateway = {
    fetchConfiguratorData,
};
